import {getThisMonth} from "../../../common/DateUtils";
import {hostList} from "../../signup/entity/Common";
import {Link} from "react-router-dom";
import SelectAdminModal from "../../../components/common/SelectAdminModal";
import {atom} from "jotai/index";
import moment from "moment";
import {phoneNumFormat} from "../../../common/StringUtils";
import styled from "styled-components";

export const adminInfoAtom = atom({})
/**
 * 상품 수집 기간 검색 아톰
 * @type {PrimitiveAtom<{endDate: string, stateDate: string}> & WithInitialValue<{endDate: string, stateDate: string}>}
 */
export const searchConditionAtom = {
  searchStartDate: getThisMonth().startDay,
  searchEndDate: getThisMonth().endDay,
  searchType: 'DEFAULT',
  keyword: '',
  pageSize: 1000,
  currentPage:1,
  username:''
}

export const selectAccountUseInfo = [
  {id: "1", value: "ALL", label: "전체"},
  {id: "2", value: "Y", label: "활성화"},
  {id: "3", value: "N", label: "비활성화"},
]
export const AdminActiveList = [
  {id: "0", value: "NORMAL", label: "활성화"},
  {id: "1", value: "SUSPEND", label: "비활성화"},
]
export const searchAccountInfo = {
  mediaType: 'ALL',
  selectAdminType: '',
  mediaSearchType: null,
  username: '',
  siteName: '',
  phoneNumber: '',
  activeYn: 'ALL',
  pageSize: 1000,
  currentPage: 1,
  searchText: ''
}
export const columnAdminData = [
  {
    name: 'status',
    header: '사용 여부',
    defaultWidth: 110,
    textAlign: 'center',
    render: ({value}) => (
        <AdminStatusBadge $active={value === 'NORMAL'}>
          <StatusDot/>
          {value === 'NORMAL' ? '활성화' : '비활성화'}
        </AdminStatusBadge>
    )
  },
  {
    name: 'email',
    header: '아이디',
    defaultWidth: 220, //가변 사이즈
    textEllipsis: false, // ... 표시
    render: ({value, data}) => {
      return (
          <SelectAdminModal formType={'admin'} title={'관리자 정보'} buttonText={value} data={data}/>
      )
    }
  },
  {
    name: 'name',
    header: '담당자명'
  },
  {
    name: 'phoneNumber',
    header: '연락처',
    render: ({value}) => <span>{phoneNumFormat(value)}</span>
  },
  {
    name: 'createdAt',
    header: '생성 일시',
    render: ({value}) => {
      return (
          <span>{moment(value).format('YYYY년 MM월 DD일')}</span>
      )
    }
  },
]

const AdminStatusBadge = styled.span`
  display:inline-flex;min-width:72px;height:26px;align-items:center;justify-content:center;gap:6px;
  padding:0 9px;border:1px solid ${({$active}) => $active ? '#c8e4d1' : '#e0e3e6'};
  border-radius:13px;background:${({$active}) => $active ? '#f1faf4' : '#f4f5f6'};
  color:${({$active}) => $active ? '#318553' : '#747c84'};font-size:9px;font-weight:700;
`;
const StatusDot = styled.span`width:6px;height:6px;border-radius:50%;background:currentColor;`;
const RequiredBadge = styled.span`
  display:inline-flex;min-width:58px;height:24px;align-items:center;justify-content:center;gap:6px;
  padding:0 9px;border:1px solid ${({$required}) => $required ? '#f1d4c2' : '#e0e3e6'};
  border-radius:12px;background:${({$required}) => $required ? '#fff4e8' : '#f4f5f6'};
  color:${({$required}) => $required ? '#d96500' : '#747c84'};font-size:9px;font-weight:700;
`;
export const columnTermData = [
  {
    name: 'title',
    header: '약관 명',
    textAlign: 'start',
    render: (props) => {
      return (
          <Link to={'/board/platformTermDetail'} state={{id: props.data.id}}
                style={{display: 'inline-block', width: '100%', textAlign: "left"}}>{props.value}</Link>
      )
    },
    flex:4
  },
  {
    name: 'requiredAgreeYn',
    header: '필수 여부',
    textAlign: 'center',
    render: (props) => {
      const required = props.value === 'Y' || props.value === true || props.value === 'REQUIRED';
      return (
          <RequiredBadge $required={required}><StatusDot/>{required ? '필수' : '선택'}</RequiredBadge>
      )
    },
    flex:1
  },
  // {
  //   name: 'patchVersion',
  //   header: '버전',
  // },
]

/**
 * 호스트 타입
 * @type
 */
export const hostType = [
  {key: 100, value: "ALL", label: "전체"},
  ...hostList
]
